import { Component, inject } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslatePipe } from '@ngx-translate/core';

export interface ConfirmationDialogField {
  label: string;
  translateLabel: boolean;
  value: string | SafeHtml;
  translateValue: boolean;
  renderValueAsHtml: boolean;
}

export interface ConfirmationDialogData {
  title?: string;
  message?: string;
  itemLabel?: string;
  itemLabelTranslate?: boolean;
  itemValue?: string | SafeHtml;
  itemValueTranslate?: boolean;
  itemValueRenderAsHtml?: boolean;
  details?: ConfirmationDialogField[];
  cancelLabel?: string;
  confirmLabel?: string;
  confirmButtonClass?: string;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  imports: [TranslatePipe],
})
export class ConfirmationDialogComponent {
  title = 'default-confirm-title';

  message = 'default-confirm-message';

  itemLabel?: string;

  itemLabelTranslate = false;

  itemValue?: string | SafeHtml;

  itemValueTranslate = false;

  itemValueRenderAsHtml = false;

  details: ConfirmationDialogField[] = [];

  cancelLabel = 'cancel';

  confirmLabel = 'leave';

  confirmButtonClass = 'btn-warning';

  private readonly dialogRef = inject(DynamicDialogRef);
  private readonly dialogConfig = inject(
    DynamicDialogConfig<ConfirmationDialogData>,
  );

  constructor() {
    Object.assign(this, this.dialogConfig.data);
  }

  asTranslatedText(value: string | SafeHtml | undefined): string {
    return typeof value === 'string' ? value : '';
  }

  dismiss() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
